<template>
    <el-row :span="24">
        <div v-show="screenSize>1" class="settingsMenuContainer">
            <div class="settingsMenuItemTitle"> {{$l('settings/name')}}  </div>
            <div v-if="$p('settings/interface')" :class="getClass('interface')" @click="navigate('interface')">  {{$l('settings/interface/settingsName')}} <span class="selectedArrow"></span> </div>
            <div v-if="$p('settings/download')" :class="getClass('download')" @click="navigate('download')"> {{$l('settings/download/settingsName')}}   <span class="selectedArrow"></span></div>
            <div v-if="$p('settings/audioRecording')" :class="getClass('audioRecording')" @click="navigate('audioRecording')"> {{$l('settings/audioRecording/settingsName')}}   <span class="selectedArrow"></span></div>
            <div v-if="$p('settings/dynamicDns/enabled')" :class="getClass('dynamicDns')" @click="navigate('dynamicDns')"> {{$l('settings/dynamicDns/settingsName')}}   <span class="selectedArrow"></span></div>
            <div v-if="$p('settings/alertMessaging/enabled')" :class="getClass('alertMessaging')" @click="navigate('alertMessaging')"> {{$l('settings/alertMessaging/settingsName')}}   <span class="selectedArrow"></span></div>
            <div v-if="$p('settings/FTPSending/enabled')" :class="getClass('FTPSending')" @click="navigate('FTPSending')"> {{$l('settings/FTPSending/settingsName')}}  <span class="selectedArrow"></span></div>
            <div v-if="$p('settings/geographicPosition')" :class="getClass('geographicPosition')" @click="navigate('geographicPosition')"> {{$l('settings/geographicPosition/settingsName')}}   <span class="selectedArrow"></span></div>
            <div v-if="$p('settings/weather') && getSettingsAddons.weather == '1'" :class="getClass('weather')" @click="navigate('weather')"> {{$l('settings/weather/settingsName')}}  <span class="selectedArrow"></span></div>
            <div v-if="$p('settings/delete') " :class="getClass('delete')" @click="navigate('delete')"> {{$l('settings/delete/settingsName')}}   <span class="selectedArrow"></span></div>
            <div v-if="$p('settings/device') && getSettingsAddons.noise == '1'" :class="getClass('device')" @click="navigate('device')"> {{$l('settings/device/settingsName')}}   <span class="selectedArrow"></span></div>
            <div v-if="$p('settings/video') && getSettingsAddons.video == '1'" :class="getClass('video')" @click="navigate('video')"> {{$l('settings/video/settingsName')}}   <span class="selectedArrow"></span></div>
            <div v-if="$p('settings/adio') && getSettingsAddons.adio == '1'" :class="getClass('adio')" @click="navigate('adio')"> {{$l('settings/adio/settingsName')}}   <span class="selectedArrow"></span></div>            
            <div v-if="$p('settings/norcloud')" :class="getClass('norcloud')" @click="navigate('norcloud')"> {{$l('settings/norcloud/settingsName')}}   <span class="selectedArrow"></span></div>
            <div  :class="getClass('statistics')" @click="navigate('statistics')"> {{$l('settings/statistics/settingsName')}}   <span class="selectedArrow"></span></div>			
            <div v-if="$p('settings/status/enabled')" :class="getClass('status')" @click="navigate('status')"> {{$l('settings/status/settingsName')}}   <span class="selectedArrow"></span></div>
        </div>
        <div class="settings-menu-top-container">
            <div v-show="screenSize<2" class="settings-menu-top">
                <div @click="menuVisible =!menuVisible" class="settingsMenuItemTitle settings-top-title"> {{$l('settings/name')}} 
                    <i v-show="!menuVisible" class="el-icon-arrow-right pull-right settings-menu-top-icon"></i>
                    <i v-show="menuVisible" class="el-icon-arrow-down pull-right settings-menu-top-icon"></i>
                </div>
                <el-collapse-transition>
                <div v-show="menuVisible" class="settings-menu-top-real">
                    <div class="settings-menu-items">
                        <div v-if="$p('settings/interface')" :class="getClass('interface')" @click="navigate('interface')">  {{$l('settings/interface/settingsName')}}  <span class="selectedArrow"></span> </div>
                        <div v-if="$p('settings/download')" :class="getClass('download')" @click="navigate('download')"> {{$l('settings/download/settingsName')}}   <span class="selectedArrow"></span></div>
                        <div v-if="$p('settings/audioRecording')" :class="getClass('audioRecording')" @click="navigate('audioRecording')"> {{$l('settings/audioRecording/settingsName')}}   <span class="selectedArrow"></span></div>
                        <div v-if="$p('settings/dynamicDns/enabled')" :class="getClass('dynamicDns')" @click="navigate('dynamicDns')"> {{$l('settings/dynamicDns/settingsName')}}   <span class="selectedArrow"></span></div>
                        <div v-if="$p('settings/alertMessaging/enabled')" :class="getClass('alertMessaging')" @click="navigate('alertMessaging')"> {{$l('settings/alertMessaging/settingsName')}}   <span class="selectedArrow"></span></div>
                        <div v-if="$p('settings/FTPSending/enabled')" :class="getClass('FTPSending')" @click="navigate('FTPSending')"> {{$l('settings/FTPSending/settingsName')}}  <span class="selectedArrow"></span></div>
                        <div v-if="$p('settings/geographicPosition')" :class="getClass('geographicPosition')" @click="navigate('geographicPosition')"> {{$l('settings/geographicPosition/settingsName')}}   <span class="selectedArrow"></span></div>
                        <div v-if="$p('settings/weather')" :class="getClass('weather')" @click="navigate('weather')"> {{$l('settings/weather/settingsName')}}  <span class="selectedArrow"></span></div>
                        <div v-if="$p('settings/delete')" :class="getClass('delete')" @click="navigate('delete')"> {{$l('settings/delete/settingsName')}}   <span class="selectedArrow"></span></div>
                        <div v-if="$p('settings/device')" :class="getClass('device')" @click="navigate('device')"> {{$l('settings/device/settingsName')}}   <span class="selectedArrow"></span></div>
                        <div v-if="$p('settings/video')" :class="getClass('video')" @click="navigate('video')"> {{$l('settings/video/settingsName')}}   <span class="selectedArrow"></span></div>
                        <div v-if="$p('settings/adio')" :class="getClass('adio')" @click="navigate('adio')"> {{$l('settings/adio/settingsName')}}   <span class="selectedArrow"></span></div> 
                        <div v-if="$p('settings/norcloud')" :class="getClass('norcloud')" @click="navigate('norcloud')"> {{$l('settings/norcloud/settingsName')}}   <span class="selectedArrow"></span></div>
                        <div :class="getClass('statistics')" @click="navigate('statistics')"> {{$l('settings/statistics/settingsName')}}   <span class="selectedArrow"></span></div>                        
                        <div v-if="$p('settings/status/enabled')" :class="getClass('status')" @click="navigate('status')"> {{$l('settings/status/settingsName')}}   <span class="selectedArrow"></span></div>
                    </div>
                </div>
                </el-collapse-transition>
            </div>
        </div>
        
        <el-row class="save-button-container" v-bind:class="{'sidebar-margin':this.screenSize > 1, 'save-margin-top':this.screenSize <= 1}">
            <el-button @click="saveClicked" :type="saving?'default':'primary'" :icon="saving?'loading':''" class="save-button" ><b>{{$l('settings/save')}} </b></el-button>
        </el-row>
        <el-row :class="containerClass" v-loading="loading">
            <keep-alive>
                <router-view v-if="loaded"></router-view>
            </keep-alive>
        </el-row>
    </el-row>
    
</template>

<style>
    .disabled-button{
        cursor: not-allowed !important;
    }
    /* Global styles for form items */
    .el-row{
        text-align: left;
    }
    .el-select{
        width:100%;
    }
    .el-form-item-full{
        width:100%;
    }
    .line{
        text-align:center;
    }
    .pull-right{
        float: right;
        padding: 10px;
    }

    /* Styles for settings */
    .settingsMenuItemTitle{
        width:calc( 100% - 15px);
        margin-left:5px;
        padding: 5px;
        background-color:#364150;
        color:#b4bcc8;
        text-align:left;
        border-bottom: 0.1px solid #424f5f;
        font-size:15px;
        color:#708096;
        line-height: 2.4; /* Da je text na centru */
        text-indent:1px;
    }
    .settingsMenuItem{
        width:calc( 100% - 15px);
        margin-left:5px;
        padding: 5px;
        background-color:#364150;
        color:#b4bcc8;
        text-align:left;
        border-bottom: 0.1px solid #424f5f;
        line-height: 2.4;
    }
    .settingsMenuContainer{
        position:fixed;
        width: 220px;
        top:40px;
        bottom:-15px;
        background-color:#364150;
        -webkit-box-shadow: inset 15px 0px 5px -13px rgba(0,0,0,0.25);
        -moz-box-shadow: inset 15px 0px 5px -13px rgba(0,0,0,0.25);
        box-shadow: inset 15px 0px 5px -13px rgba(0,0,0,0.25);
        overflow-y: scroll;
    }
    .settings-menu-top-container{
        position: absolute;
        z-index: 5;
        left: 0px;
        right: 0px;
    

    }
    .settings-menu-top-icon{
        margin-right: 10px;
    }
    .settings-top-title{
        width: 100%;
    }
    .settings-menu-top{
        width: calc( 100% + 5px);
        margin-left: -5px;
        overflow: hidden;
        position: fixed;
    }
    .settings-container{
        margin-left: 25px;
        margin-top:25px;
        margin-right: 25px;
        padding:20px;
        border: 1px solid #e1e5ec;
    }
    .settings-menu-top-real{
        overflow-y: scroll;
        overflow-x:hidden;
        width:75%;
    }
    .sidebar-margin{
        margin-left:250px;
    }
    .settingsMenuItem:hover{
        background-color:#5E738B;
        cursor:pointer;
    }
    /* Tuki je ko je menu selectan */
    .settingsMenuItemSelected{
        width:calc( 100% - 10px);
        padding: 5px;
        background-color:#36c6d3;
        color:white;
        text-align:left;
        border-bottom: 0.1px solid #424f5f;
        line-height: 2.4;
        padding-left:20px;
    }

    .settingsMenuItemSelected > .selectedArrow{
        display: block;
        float: right;
        position: relative;
        left: 6px;
        right: 0;
        top: 5px;
        background: 0 0;
        width: 0;
        height: 0;
        border-top: 15px solid transparent;
        border-bottom: 15px solid transparent;
        border-right: 15px solid #fff;

    }
    .save-button-container{
        margin-bottom: -15px;
        margin-top: 10px;
    }
    .save-button{
        float:right;
        margin-right: 25px !important;
        width: 100px;
    }

    .save-margin-top{
        margin-top: 55px;
    }

    .settings-menu-items{
        overflow-y: scroll;
    overflow-x: hidden;
    height: calc(100vh - 85px);
    }

</style>
<script>
import {demutateSettings} from '@/common/utils';
import { mapGetters, mapActions } from 'vuex'
import {getSettings,saveSettings,saveLocalSettings,createUnsavedLocalSettings, getFirmware, saveUser} from '@/store/actions';

export default {
    components:{
    },
    data:function(){
        return{
            activeMenu:"geographic-position",
            screenSize:2,
            menuVisible: true,
            loading: false,
            loaded: false,
            saving: false,
        }
    },
    computed:{
        ...mapGetters([
            'getSettings',
            'getSettingsAddons',
            'getUnsavedLocalSettings',
            'getUser'
        ]),
        path:function(){            
            return this.$route.path.split('/')[2];
        },
        containerClass: function(){
            return 'settings-container' + ((this.screenSize > 1)?' sidebar-margin':'')
        }
    },
    watch:{
        '$mq.resize' : 'screenResize',
        'getSettings': function(newSettings){
            if(newSettings.device){
                this.loading = false;
                this.loaded = true;
            }
            else
                this.loading = true;
        }
    },
    methods:{
        ...mapActions([
            'setScreenSize'
        ]),
        screenResize(){
            if(this.$mq.below(768)){
                this.screenSize=0;
            }else if(this.$mq.above(1199)){
                this.screenSize=3;
            }
            else if(this.$mq.above(991)){
                this.screenSize=2;
            }
            else if(this.$mq.above(766)){
                this.screenSize=1;
            }
            this.setScreenSize(this.screenSize);
            this.menuVisible = false;
        },
        makeActive: function(name){
            this.activeMenu = name //Because I did not have 'this' word the code did not work correctly
        },
        getClass:function(menu){
            if(menu == this.path) return 'settingsMenuItemSelected';
            if(this.getSettingsAddons[menu]=='0') return 'settingsMenuItem disabled-button';
            return 'settingsMenuItem';
        },
        navigate: function(name){
            if(this.getSettingsAddons[name]=='0') return;
            this.menuVisible = false;
            this.$router.push("/settings/" + name);
        },
        saveClicked: function(){
            this.saving = true; 
            //Demutate local settings
            var rtvalueTime = new Date( this.getUnsavedLocalSettings.interface.rtvaluesPicker);
            this.getUnsavedLocalSettings.interface.rtvalues = 
                rtvalueTime.getHours()*3600 + 
                rtvalueTime.getMinutes()*60 + rtvalueTime.getSeconds();

            saveLocalSettings(this.$store, this.$localStorage, this.getUnsavedLocalSettings);
            var settings = demutateSettings(this.getSettings);
            saveSettings(this.$store, settings);
            setTimeout(()=>{this.saving = false;},1000);
        }
    },
    mounted: function(){
       

        if(!this.$p('settings/enabled')){
            this.$router.push('/');
            return;
        }
        if(this.$p('settings/'+this.path+'/enabled') !== undefined){
            if(!this.$p('settings/'+this.path+'/enabled')){
                this.$router.push('/');
                return;
            }
        }else{
            if(!this.$p('settings/'+this.path)){
                this.$router.push('/');
                return;
            }
        }
        getFirmware(this.$store);
        this.screenResize();
        this.loading = true;
        if(this.getSettings.device){
            this.loading = false;
            this.loaded = true;
        }
        //alert('ok')
        createUnsavedLocalSettings(this.$store);
        /*getSettings(this.$store)
            .then((settings)=>{
                //saveSettings(this.$store, settings);
                this.loading = false;
                //settings received
            })
        */
    }
}
</script>


// WEBPACK FOOTER //
// Settings.vue?3704b89c